import {PropsWithChildren} from 'react';
import {AssetDetails} from './AssetDetails';
import {AdditionalAssetDataContext} from './AdditionalAssetDataContext';
import {HazardSelectionContext} from "./HazardAssetSelectionContext";

export const AssetContext = (props: PropsWithChildren) => {
  return (
    <AssetDetails>
      <AdditionalAssetDataContext>
        <HazardSelectionContext>
          {props.children}
        </HazardSelectionContext>
      </AdditionalAssetDataContext>
    </AssetDetails>
  );
};